var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNews2 = function SvgNews2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#727A86",
    d: "M12.667 3.333v9.334H3.333V3.333zm0-1.333H3.333C2.6 2 2 2.6 2 3.333v9.334C2 13.4 2.6 14 3.333 14h9.334C13.4 14 14 13.4 14 12.667V3.333C14 2.6 13.4 2 12.667 2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#727A86",
    d: "M9.333 11.333H4.666V10h4.667zm2-2.666H4.666V7.333h6.667zm0-2.667H4.666V4.667h6.667z"
  })));
};
export { SvgNews2 as ReactComponent };
export default __webpack_public_path__ + "79384dfc874973772d071813be384850.svg";